import React from 'react';
import { Typography } from '@mui/material';

const HeaderTraining = () => {
  return <Typography variant='h2'>Treinamentos</Typography>;
};

export default HeaderTraining;
